import { LogoutOptions } from '@auth0/auth0-react';
import { RouterInstance } from 'src/features/integrations/connectors/types/IntegrationConnectorTypes';
import mixpanel from 'src/shared/lib/mixpanel';

export function createOutlookDialogLogout(
  isAuthenticated: boolean,
  logout: (options?: LogoutOptions) => Promise<void>,
  router: RouterInstance
) {
  return async function () {
    let dialog: Office.Dialog;

    const processLogoutMessage = async (args: { message: string; origin: string | undefined } | { error: number }) => {
      dialog.close();
      if ('error' in args) {
        return;
      }
      const messageFromDialog = JSON.parse(args.message);
      if (messageFromDialog.status === 'success') {
        mixpanel.reset();
        localStorage.clear();
        router.push('/plugins/outlook/login');
      } else {
        console.error('Logout failed.', messageFromDialog);
      }
    };

    if (isAuthenticated) {
      localStorage.clear();
      await logout({
        openUrl: async (url: string) => {
          const redirect = encodeURIComponent(url);
          const bounceURL = location.origin + '/plugins/outlook/dialog?redirect=' + redirect;

          Office.context.ui.displayDialogAsync(
            bounceURL,
            {
              height: 30,
              width: 30,
              displayInIframe: false,
              promptBeforeOpen: false,
            },
            function (result) {
              dialog = result.value;
              dialog.addEventHandler(Office.EventType.DialogMessageReceived, processLogoutMessage);
            }
          );
        },
        logoutParams: {
          returnTo: location.origin + '/plugins/outlook/dialog',
        },
      });
    } else {
      router.push('/plugins/outlook/login');
    }
  };
}
